import React from 'react';

import {
  extLnkDeliveryIssues,
  extLnkHelpAndSupport,
  extLnkHelpAndSupportStarTrack,
  extLnkMissingItem,
  extLnkMissingItemLoggedIn,
} from 'config/track-config';
import { Milestone } from 'models/shipments/Payload';
import { useAppSelector } from 'store/store';

import { selectIsAuthed } from '../../../../store/customer';
import { useCurrentArticle } from '../../hooks/shipment.hooks';
import AccordionWrapper from '../AccordionWrapper/AccordionWrapper';
import LinkRow from '../RowCard/LinkRow/LinkRow';
import RowCard from '../RowCard/RowCard';
import { ROW_CARD_ICONS } from '../RowCard/RowContent/RowContent';
import {
  DELIVERY_ISSUES_ROW_TEST_ID,
  GET_HELP_ROW_TEST_ID,
  HELP_AND_SUPPORT_OPTIONS_TEST_ID,
  MISSING_ITEM_ROW_TEST_ID,
} from './HelpAndSupportOptions.test-ids';

const HelpAndSupportOptions: React.FC = () => {
  const authenticated = useAppSelector(selectIsAuthed);

  const { address, articleId = '', events, isStarTrackPremiumArticle } = useCurrentArticle() || {};
  const latestMilestone = events?.[0]?.milestone ?? Milestone.PENDING;
  const heading = 'Help and support';

  const helpAndSupportLink = isStarTrackPremiumArticle ? extLnkHelpAndSupportStarTrack : extLnkHelpAndSupport;
  const delivered = latestMilestone === Milestone.DELIVERED;
  const url = authenticated ? extLnkMissingItemLoggedIn : extLnkMissingItem;
  let missingItemUrl = url + articleId;
  if (address?.deliveryPointId) missingItemUrl = missingItemUrl + '&dpId=' + address.deliveryPointId;

  const helpAndSupportOptions = (
    <>
      {delivered ? (
        <>
          <LinkRow
            icon={ROW_CARD_ICONS.parcel}
            text='Report this parcel as missing'
            href={missingItemUrl}
            target='_blank'
            data-testid={MISSING_ITEM_ROW_TEST_ID}
          />
          <LinkRow
            icon={ROW_CARD_ICONS.help}
            text='Get help with something else'
            href={extLnkDeliveryIssues}
            target='_blank'
            data-testid={DELIVERY_ISSUES_ROW_TEST_ID}
          />
        </>
      ) : (
        <>
          {/* MANAGE ENQUIRY - TODO: currently out of scope */}
          {/* <RowCardRow
            icon={RowCardIcons.profileSettings}
            text='Manage enquiry'
            chevron
            data-testid={}
          /> */}

          <LinkRow
            icon={ROW_CARD_ICONS.help}
            text='Get help'
            href={helpAndSupportLink}
            target='_blank'
            data-testid={GET_HELP_ROW_TEST_ID}
          />
        </>
      )}
    </>
  );

  return (
    <AccordionWrapper heading={heading} id='accordionHelpandsupportOptions' isGroupLast>
      <RowCard groupHeading={heading} data-testid={HELP_AND_SUPPORT_OPTIONS_TEST_ID}>
        {helpAndSupportOptions}
      </RowCard>
    </AccordionWrapper>
  );
};

export default HelpAndSupportOptions;
